export default __webpack_public_path__ + "static/media/featDesktop.b8716660.png";